export default "__VITE_PUBLIC_ASSET__2795cc85__"